import React from 'react';
import Container from './container/Container';
import './assets/style.css'
import { LocalProvider } from './context/LocalContext';
import { ProductProvider } from './context/ProductContext';


// const RedirectComponent = () => {
//   useEffect(() => {
//     document.body.style.display = 'none';
//     window.location.href = 'https://tastefusion.life/'; 
//   }, []);

//   return null; 
// };


function App() {
  return (
    <div>
      {/* <RedirectComponent /> */}
      <LocalProvider >
        <ProductProvider >
      <Container />
      </ProductProvider>
      </LocalProvider>
    </div>
  );
}

export default App;
